import { FormControl, FormHelperText, Grid, TextField } from "@mui/material";
import React from "react";
import { StyledLabel } from "../../../common/components/InputLabel";

const ToExtractInput = ({ register, errorMessage }) => {
  return (
    <>
      <Grid item xs={3} sx={{ marginTop: 1 }}>
        <StyledLabel error={Boolean(errorMessage)}>
          Teeth to be extracted
        </StyledLabel>
        <FormHelperText error={Boolean(errorMessage)}>
          {errorMessage}
        </FormHelperText>
      </Grid>
      <Grid item xs={9}>
        <TextField error={Boolean(errorMessage)} size="small" {...register} />
      </Grid>
    </>
  );
};

export default ToExtractInput;
